import React from "react";
import { useI18n } from "../i18n/LanguageContext";
import { useRequestModal } from "../context/RequestModalContext";
import { Reveal } from "../components/Reveal";

// Reusable cinematic service section, alternating image side.
export const ServiceSection = ({ id, ns, image, category, reverse = false, extra = null }) => {
  const { t } = useI18n();
  const { openRequest } = useRequestModal();
  const services = t(`${ns}.services`) || [];

  return (
    <section id={id} className="py-24 md:py-36 border-b border-vm-border" data-testid={`service-${id}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`grid md:grid-cols-2 gap-12 md:gap-20 items-center ${reverse ? "md:[direction:rtl]" : ""}`}>
          <Reveal className={`${reverse ? "md:[direction:ltr]" : ""}`}>
            <div className="overflow-hidden">
              <img
                src={image}
                alt={t(`${ns}.title`)}
                loading="lazy"
                className="w-full h-[340px] md:h-[560px] object-cover hover:scale-105 transition-transform duration-[1200ms] ease-out"
              />
            </div>
          </Reveal>

          <Reveal delay={0.1} className={`${reverse ? "md:[direction:ltr]" : ""}`}>
            <p className="vm-label mb-5">{t(`${ns}.label`)}</p>
            <h2 className="font-serif font-light leading-[1.02] text-3xl md:text-5xl mb-6">{t(`${ns}.title`)}</h2>
            <p className="text-vm-text2 font-light leading-relaxed max-w-lg mb-8">{t(`${ns}.body`)}</p>

            <ul className="grid grid-cols-2 gap-x-8 gap-y-2 mb-10 max-w-lg">
              {services.map((s, i) => (
                <li key={i} className="text-sm text-vm-text2 flex items-center gap-2">
                  <span className="w-1 h-1 bg-vm-accent shrink-0" /> {s}
                </li>
              ))}
            </ul>

            {extra}

            <button onClick={() => openRequest(category)} className="vm-btn-ghost px-8 py-3.5 text-xs tracking-[0.2em] uppercase" data-testid={`service-cta-${id}`}>
              {t(`${ns}.cta`)}
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
